export default "__VITE_ASSET__d114e081__"